<template>
  <div class="faq__item clearfix" :class="{ small: small }">
    <h4 role="tab" :id="`heading-${faq.id}`">
      <button
        @click.prevent="toggle"
        class="butn"
        :aria-expanded="isOpen"
        :aria-controls="`collapse-${faq.id}`"
      >
        <i v-html="faqIcon"></i> {{ faq.question }}
      </button>
    </h4>
    <Collapse
      ref="collapse"
      :isTransitioning="isTransitioning"
      :id="`collapse-${faq.id}`"
      role="tabpanel"
      :aria-labelledby="`heading-${faq.id}`"
      @transitionchanged="onTransitionChanged"
    >
      <div class="wrapper" v-html="faq.answer"></div>
    </Collapse>
  </div>
</template>

<script>
import Collapse from "../common/Collapse";
import PlusIcon from "../../assets/icons/faq-plus.svg";
import MinusIcon from "../../assets/icons/faq-minus.svg";

export default {
  name: "items",
  props: {
    faq: Object,
    activeItem: {},
    isTransitioning: Boolean,
    small: Boolean
  },
  components: {
    Collapse
  },
  data() {
    return {
      isOpen: false
    };
  },
  computed: {
    faqIcon() {
      return this.isOpen ? MinusIcon : PlusIcon;
    }
  },
  methods: {
    // TODO: should we call toggle here + $refs.toggle or wait for event emitter from collapse ???
    toggle() {
      if (this.isTransitioning) {
        return;
      }

      if (this.isOpen) {
        this.onClose();
      } else {
        this.onOpen();
      }

      this.$refs.collapse.toggle();
    },
    onOpen() {
      this.isOpen = true;
      this.$emit("open");
    },
    onClose() {
      this.isOpen = false;
      this.$emit("close");
    },
    onTransitionChanged(result) {
      this.$emit("transitionchanged", result);
    }
  },
  watch: {
    activeItem(id) {
      if (this.isOpen && this.faq.id !== id) {
        this.onClose();
        this.$refs.collapse.hide();
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../assets/styles/vars";
@import "../../assets/styles/mixins";

.clearfix {
  @include clearfix;
}

.butn {
  @include butn;
}

.faq__item {
  border-bottom: 1px solid #8d8d8d;

  h4 {
    margin: 38px 20px 30px 50px;
    font-family: $sarala;
    font-size: 26px;
    letter-spacing: 0.08em;
    line-height: 1.5;

    button {
      display: block;
      width: 100%;
    }

    @media (max-width: $screen-xs) {
      margin-left: 35px;
      font-size: 22px;
      line-height: 1.2;
    }
  }

  button {
    position: relative;
    text-align: left;

    &:hover {
      color: $mainRed;
      text-decoration: none;
    }

    &:focus {
      color: lighten($mainRed, 20%);
      text-decoration: none;
    }

    i {
      position: absolute;
      top: 13px;
      left: -48px;
      display: block;
      font-size: 22px;
      color: $mainRed;
      line-height: 0;

      @media (max-width: $screen-xs) {
        top: 4px;
        left: -33px;
        font-size: 18px;
      }
    }

    &[aria-expanded="true"] {
      color: $mainRed;
    }
  }

  // wrapper for collapsa panel
  .wrapper {
    padding: 0 20px 60px 50px;
    font-size: 16px;
    line-height: 1.5;
    letter-spacing: 0.03em;

    @media (max-width: $screen-xs) {
      padding-left: 35px;
    }
  }

  p {
    margin: 0 0 15px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      color: $mainRed;

      &:hover,
      &:focus {
        color: darken($mainRed, 12%) !important;
      }
    }
  }
}

.faq__item.small {
  border-bottom-color: #333;

  h4 {
    position: relative;
    margin: 0;
    padding: 22px 20px 22px 34px;
    font-size: 16px;
  }

  button {
    position: static;
    text-transform: uppercase;

    i {
      top: 50%;
      left: 0;
      transform: translateY(-50%);
      font-size: 14px;
    }
  }

  .wrapper {
    padding-bottom: 30px;
    padding-left: 34px;
  }
}
</style>

<style lang="scss">
@import "../../assets/styles/vars";

.faq__item button i svg {
  width: 1em;
  height: 1em;
  fill: currentColor;
  margin-top: -0.175em;
}

.faq__item .wrapper {
  p {
    margin: 0 0 15px;

    &:last-child {
      margin-bottom: 0;
    }

    a {
      text-decoration: none;
      color: $mainRed;
      transition: color $linkTransition;

      &:hover,
      &:focus {
        color: darken($mainRed, 12%) !important;
      }
    }
  }
}
</style>
